import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import { Colors } from 'src/utils/color';

const StyledCard = styled.div<Props>`
    background-color: ${(props) =>
        props.backgroundColor || Colors.extra.white}; /* White background for light theme */
    border-radius: 8px;
    border: 1px solid ${Colors.theme.sidebar_border};
    width: ${(props) => props.width || '100%'};
    height: ${(props) => props.height || '100%'};
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;

interface Props {
    children?: React.ReactNode;
    backgroundColor?: string;
    width?: string;
    height?: string;
    borderRadius?: string;
    className?: string;
    onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
}

const Card: FunctionComponent<Props> = ({ children, ...props }: Props) => {
    return <StyledCard {...props}>{children}</StyledCard>;
};

export default Card;
